import * as constants from './constants';

const initialState = {
  fulfilment: constants.FULFILMENT.DELIVERY,
  submitting: false,
  scheduledOrder: false,
  submissionError: null,
  // Identifies one checkout attempt end to end, so a retried submit resolves to
  // the order the first attempt created instead of placing a second one.
  attemptId: null,
  // The order awaiting online payment, as the server described it.
  placedOrder: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_FULFILMENT:
      return { ...state, fulfilment: action.payload, submissionError: null };
    case constants.SET_SUBMITTING:
      return { ...state, submitting: action.payload };
    case constants.SET_SUBMISSION_ERROR:
      return { ...state, submitting: false, submissionError: action.payload };
    case constants.START_ATTEMPT:
      return {
        ...state, attemptId: action.payload, submissionError: null, placedOrder: null,
      };
    case constants.SET_PLACED_ORDER:
      return { ...state, placedOrder: action.payload };
    case constants.CHANGE_SCHEDULED_ORDER:
      return { ...state, scheduledOrder: action.payload, submissionError: null };
    default:
      return state;
  }
};

export default reducer;
